import React, { PropsWithChildren } from "react";

const NotesText = (props: PropsWithChildren<{}>) => {
  return <span className="NotesText">{props.children}</span>;
};

export default NotesText;
